import React from 'react';
import { DMRVPageTemplate } from '../components/dmrv/DMRVPageTemplate';
export function RenewableEnergy() {
  return <DMRVPageTemplate id="energy" tagline="Renewable Energy | Uganda" headline="Carbon Credit Verification for Clean Energy Projects" highlightWord="Clean Energy" description="With 600+ mini-grids planned and solar adoption accelerating, Uganda's renewable energy sector offers significant carbon credit opportunities. CarbonSafe provides automated DMRV for every kilowatt-hour of clean energy generated." badges={['Gold Standard', 'CDM Compliant', 'SDG Aligned']} heroEmoji="⚡" floatingIcons={[{
    emoji: '☀️',
    position: 'top'
  }, {
    emoji: '🔋',
    position: 'right'
  }, {
    emoji: '🏘️',
    position: 'left'
  }]} statsHeadline="Uganda's clean energy transition" statsSubtext="Renewable energy is transforming rural Uganda while creating verified carbon reduction opportunities." stats={[{
    value: '600+',
    label: 'Mini-grids Planned',
    detail: "Under Uganda's Rural Electrification Strategy to reach 80% access by 2030"
  }, {
    value: '57%',
    label: 'Without Electricity',
    detail: 'Of Ugandans lack access to grid electricity, the 5th lowest rate globally'
  }, {
    value: '1.2M',
    label: 'Tons CO₂/year',
    detail: 'Potential emission reductions from displacing diesel and kerosene with solar'
  }, {
    value: '$35M+',
    label: 'Credit Revenue',
    detail: "Annual carbon credit potential from Uganda's renewable energy projects"
  }]} howItWorksVerticalName="renewable energy" howItWorksSubtext="From smart meter to credit registry, four steps to verified clean energy impact." howItWorksSteps={[{
    icon: 'ZapIcon',
    title: 'Smart Metering',
    description: 'IoT-enabled meters capture real-time generation and consumption at solar and mini-grid sites.'
  }, {
    icon: 'BarChart3Icon',
    title: 'Baseline Calculation',
    description: 'Grid emission factors quantify exactly how much CO₂ each kilowatt-hour displaces.'
  }, {
    icon: 'HomeIcon',
    title: 'Household Impact',
    description: 'Track kerosene and diesel displacement at household level for accurate emission reductions.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Credit Generation',
    description: 'AMS-I.L/AMS-I.F compliant credits issued with continuous metering verification.'
  }]} impactImageUrl="https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=800&h=500&fit=crop&crop=center" impactImageAlt="Solar panel installation powering rural communities" impactTagline="Clean Energy, Verified Impact" impactHeadline="Every kilowatt-hour measured, every credit earned" impactDescription="CarbonSafe's smart metering infrastructure captures real-time generation data from solar installations and mini-grids, turning clean energy production into verified, tradeable carbon credits." impactCtaText="Explore Energy Solutions" featuresHeadline="Automating clean energy" featuresHighlight="carbon verification" featuresSubtext="Renewable energy DMRV requires continuous metering, baseline calculations, and grid displacement analysis." features={[{
    icon: 'ZapIcon',
    title: 'Smart Metering',
    description: 'Real-time energy generation and consumption data from IoT-enabled meters at solar installations and mini-grid connection points.'
  }, {
    icon: 'SunIcon',
    title: 'Solar Performance',
    description: 'Panel-level monitoring of generation capacity, degradation rates, and maintenance schedules for accurate lifetime emission calculations.'
  }, {
    icon: 'BarChart3Icon',
    title: 'Baseline Emissions',
    description: "Grid emission factor calculations using Uganda's energy mix data, quantifying exactly how much CO₂ each kWh of solar displaces."
  }, {
    icon: 'HomeIcon',
    title: 'Household Impact',
    description: 'Track kerosene and diesel displacement at household level, from lighting to phone charging to productive use applications.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Methodology Compliance',
    description: 'Automated compliance with AMS-I.L (solar) and AMS-I.F (mini-grid) methodologies for Gold Standard and CDM registration.'
  }, {
    icon: 'GlobeIcon',
    title: 'SDG Co-benefits',
    description: 'Quantify contributions to SDG 7 (Clean Energy), SDG 13 (Climate Action), and SDG 1 (Poverty Reduction) for premium credit pricing.'
  }]} ctaHeadline="Every kilowatt counts." ctaHighlight="Power verified impact." ctaSubtext="Join energy developers using CarbonSafe to monetize clean energy through high-integrity carbon credits." ctaButtonText="Start Your Energy Project" platformPreview={{
    headline: 'Clean energy verification in',
    highlightWord: 'one dashboard',
    subtext: 'Monitor energy generation, emission displacement, and carbon credit issuance across all installations.',
    urlPath: 'energy',
    projectName: 'Soroti Solar Mini-Grid Cluster',
    statusLabel: 'Generating',
    sidebarItems: [{
      icon: 'Dashboard',
      label: 'Dashboard',
      active: true
    }, {
      icon: 'Sites',
      label: 'Sites'
    }, {
      icon: 'Meters',
      label: 'Meters'
    }, {
      icon: 'Baselines',
      label: 'Baselines'
    }, {
      icon: 'Reports',
      label: 'Reports'
    }, {
      icon: 'Settings',
      label: 'Settings'
    }],
    stats: [{
      label: 'Sites Active',
      value: '24'
    }, {
      label: 'Generation Today',
      value: '847 kWh',
      highlight: true
    }, {
      label: 'tCO₂e Displaced',
      value: '2,140'
    }, {
      label: 'Credits Value',
      value: '$42.8K'
    }],
    chartLabel: 'Daily Energy Generation (kWh)',
    activityItems: [{
      icon: 'ZapIcon',
      iconColor: 'text-carbon-bright',
      label: 'Meter #24 reading synced',
      detail: '34.2 kWh generated',
      time: '5m ago'
    }, {
      icon: 'BarChart3Icon',
      iconColor: 'text-emerald-500',
      label: 'Baseline recalculated',
      detail: 'Grid EF: 0.67 tCO₂/MWh',
      time: '45m ago'
    }, {
      icon: 'ShieldCheckIcon',
      iconColor: 'text-blue-500',
      label: 'Credits batch #8 issued',
      detail: '180 tCO₂e verified',
      time: '6h ago'
    }]
  }} data-id="element-1797" />;
}